import { useEffect, useMemo, useState } from "react";
import { getAvailableGenres } from "../services/artist.service";
import { useLocale } from "../i18n/locale";

export default function useGenreOptions() {
  const { locale } = useLocale();
  const [genres, setGenres] = useState(["All"]);
  useEffect(() => {
    let active = true;
    getAvailableGenres().then((items) => {
      if (active) setGenres(items);
    }).catch(() => {});
    return () => { active = false; };
  }, []);
  return useMemo(() => ["All", ...genres.filter((genre) => genre !== "All")
    .sort(new Intl.Collator(locale).compare)], [genres, locale]);
}
